
import { MenuIcon } from "lucide-react";
import { Button } from "@/components/atoms/Button";
import { useSidebar } from "@/core/context/SideBarContext";
import { cn } from "@/utils/cn";

export const SidebarTrigger = ({
    className,
    onClick,
    ...props
}: React.ComponentProps<typeof Button>) => {
    const { toggleSidebar } = useSidebar()

    return (
        <Button
            data-sidebar="trigger"
            data-slot="sidebar-trigger"
            variant="ghost"
            size="xs"
            className={cn("size-7", className)}
            onClick={(event) => {
                onClick?.(event)
                toggleSidebar()
            }}
            {...props}
        >
            <MenuIcon className="w-7 h-7" />
            <span className="sr-only">Toggle Sidebar</span>
        </Button>
    )
}